import CollapsibleComponent from 'components/CollapsibleComponent';
import FormValidationComponent from 'components/FormValidationComponent';
import JumpToComponent from 'components/JumpToComponent';
import MobileMastheadComponent from 'components/MobileMastheadComponent';
import NotificationComponent from 'components/NotificationComponent';
import PrimaryNavComponent from 'components/PrimaryNavComponent';

const ComponentManifest = {
    CollapsibleComponent,
    FormValidationComponent,
    JumpToComponent,
    MobileMastheadComponent,
    NotificationComponent,
    PrimaryNavComponent,
};

export default ComponentManifest;
